import React, { useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { IconArrowNarrowRight } from "@tabler/icons-react";

const Projects = () => {
  const [activeTab, setActiveTab] = useState("1"); // Default to "All" tab

  // Assuming this is part of a React component
  // Define the projects object outside the render/return statement
  const projects = {
    1: [
      { img: "assets/images/service-details-products-2.png", title: "Web Application" },
      { img: "assets/images/service-details-4-contact-us.png", title: "Mobile App" },
      { img: "assets/images/service-details-4-benefits.png", title: "API Integration"},
      { img: "assets/images/service-details-4-quality-2.png", title: "Backend System"},
      { img: "assets/images/service-details-products-7.png", title: "UI/UX Design" },
      { img: "assets/images/service-details-products-1.png", title: "Branding" },
      { img: "assets/images/service-details-4-project-calculation.png", title: "Graphic Design" },
      { img: "assets/images/service-details-products-3.png", title: "Web Layout" },
      { img: "assets/images/service-details-3-quote.png", title: "Security Audit" },
      { img: "assets/images/service-details-4-benefits.png", title: "Firewall Setup" },
      { img: "assets/images/service-details-4-quality-1.png", title: "Penetration Testing" },
      { img: "assets/images/service-details-4-quality-2.png", title: "Encryption Solution" },
    ],
    2: [
      { img: "assets/images/service-details-products-2.png", title: "Web Application" },
      { img: "assets/images/service-details-4-contact-us.png", title: "Mobile App" },
      { img: "assets/images/service-details-4-benefits.png", title: "API Integration" },
      { img: "assets/images/service-details-4-quality-2.png", title: "Backend System" },
    ],
    3: [
      { img: "assets/images/service-details-products-7.png", title: "UI/UX Design"},
      { img: "assets/images/service-details-products-1.png", title: "Branding" },
      { img: "assets/images/service-details-4-project-calculation.png", title: "Graphic Design"},
      { img: "assets/images/service-details-products-3.png", title: "Web Layout" },
    ],
    4: [
      { img: "assets/images/service-details-3-quote.png", title: "Security Audit"},
      { img: "assets/images/service-details-4-benefits.png", title: "Firewall Setup" },
      { img: "assets/images/service-details-4-quality-1.png", title: "Penetration Testing" },
      { img: "assets/images/service-details-4-quality-2.png", title: "Encryption Solution" },
    ],
};


  // In your render/return statement:

  return (
    <section className="pb-[60px] lg:pb-[120px]">
      <div className="container" >
        <div className="mx-auto max-w-[998px] text-center" data-aos="fade-right">
          <h5 className="h5 mb-3" style={{ color: "rgb(0, 109, 178)" }}>
            We Provide World-class IT-services.
          </h5>
          <h3 className="h3 mb-2 text-title">
            Successfully completed thousands of projects
          </h3>
        </div>

        <div
          className="tab-button-container mx-auto flex max-w-max flex-wrap justify-center gap-2.5 rounded-[40px] border border-gray p-2.5"
          style={{ marginBottom: "50px" }}
        >
          {["1", "2", "3", "4"].map((tab, index) => (
          <button
          key={index}
          onClick={() => setActiveTab(tab)}
          className={`rounded-[30px] px-4 py-2.5 font-medium md:px-5 md:py-3 
          border border-gray transition-all duration-300
          ${activeTab === tab ? "text-white" : "bg-white text-black"}`}
          style={
            activeTab === tab ? { backgroundColor: "rgb(0, 109, 178)" } : {}
          }
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "rgb(0, 109, 178)";
            e.target.style.color = "white";
          }}
          onMouseLeave={(e) => {
            if (activeTab !== tab) {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "black"; // Set inactive tabs text color to black
            }
          }}
        >
          {tab === "1"
            ? "All"
            : tab === "2"
            ? "Development"
            : tab === "3"
            ? "Design"
            : "Security"}
        </button>
        
          ))}
        </div>

        {/* Tab content */}
        <div className="mt-10 grid grid-cols-12 gap-6 lg:mt-[60px] container m-auto"  data-aos="fade-down">
          {projects[activeTab].map((project, index) => (
            <div
              key={index}
              className="col-span-12 rounded-lg border border-gray p-2.5 duration-300 hover:border-primary md:col-span-6 lg:col-span-4 xl:col-span-3 border border-primary rounded shadow"
            >
              <img
                className="w-100 "
                style={{height:'25vh'}}
                src={project.img}
                alt={project.title}
              />
              <a
                href={project.link}
                className="flex items-center justify-between px-2.5 pb-3 pt-5 md:pb-5 md:pt-7"
              >
                <h6
                  className="font-semibold text-title"
                  style={{ color: "rgb(0, 109, 178)" }}
                >
                  {project.title}
                </h6>
                <span
                  className="flex items-center justify-center rounded-full p-3 text-n8"
                  style={{ backgroundColor: "rgb(0, 109, 178)" }}
                >
                  <IconArrowNarrowRight className="w-6 h-6 text-white" />
                </span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
